"use client";
import { jsx } from "react/jsx-runtime";
import { CostcoBox } from "../../../Util/CostcoBox.js";
import GenericImageHandler from "../../../Util/GenericImageHandler.js";
function CardIcon({ alt, url }) {
  if (!url) {
    return null;
  }
  return /* @__PURE__ */ jsx(CostcoBox, { children: /* @__PURE__ */ jsx(
    GenericImageHandler,
    {
      src: url,
      alt: alt || "",
      sx: {
        borderRadius: "50%",
        height: "80px",
        width: "80px"
      }
    }
  ) });
}
export {
  CardIcon
};
